export default "__VITE_ASSET__CjNwGCVu__"